exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.columnlistBox[data-v-63a0b5f0] {\n    margin-top: 0;\n}\n.columnlistBox .column_li[data-v-63a0b5f0], .columnlistBox .lastcolumn_li[data-v-63a0b5f0] {\n      height: auto;\n      width: auto;\n      margin: 10px 20px;\n}\n}\n", ""]);

